import { useState, useCallback } from 'react';
import { getHousekeepers } from '../api/housekeeperApi';

// 排序函数：按状态（draft→pending→published），同状态按更新时间降序
const sortHousekeepers = (list) => {
  const statusOrder = { 'draft': 1, 'pending': 2, 'published': 3 };
  return [...list].sort((a, b) => {
    const statusA = statusOrder[a.resume_status] || 1;
    const statusB = statusOrder[b.resume_status] || 1;

    // 先按状态排序
    if (statusA !== statusB) {
      return statusA - statusB;
    }

    // 同状态按更新时间降序（最新的在前）
    const timeA = new Date(a.updated_at || 0).getTime();
    const timeB = new Date(b.updated_at || 0).getTime();
    return timeB - timeA;
  });
};

export function useHousekeepers() {
  const [housekeepers, setHousekeepers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchHousekeepers = useCallback(async () => {
    try {
      const res = await getHousekeepers();
      const sorted = sortHousekeepers(res.data);
      setHousekeepers(sorted);
    } catch (e) {
      if (e.response?.status === 401) return;
      console.error('获取阿姨列表失败:', e);
    }
  }, []);

  const filteredHousekeepers = housekeepers.filter(hk => {
    const q = searchQuery.toLowerCase();
    return hk.name.toLowerCase().includes(q) ||
      (hk.phone && hk.phone.includes(q)) ||
      (hk.birthplace && hk.birthplace.toLowerCase().includes(q));
  });

  const stats = {
    total: housekeepers.length,
    draft: housekeepers.filter(h => (h.resume_status || 'draft') === 'draft').length,
    pending: housekeepers.filter(h => h.resume_status === 'pending').length,
    published: housekeepers.filter(h => h.resume_status === 'published').length,
  };

  return { housekeepers, setHousekeepers, filteredHousekeepers, searchQuery, setSearchQuery, stats, fetchHousekeepers };
}